import React, { Component } from 'react'
import CreatableSelect from 'react-select/creatable'
import { styles } from './Styles'
import withStyles from '@material-ui/core/styles/withStyles'
import classNames from 'classnames'

const toOption = v => (typeof v === 'string' ? { label: v, value: v } : v || {})

const arrEq = (a = [], b = []) => a.length === b.length && a.every((v, i) => v === b[i])

class TagSelection extends Component {
  state = {
    value: [],
    inputValue: '',
  }

  componentDidMount() {
    const { defaultValue = [] } = this.props
    this.setState({ value: defaultValue })
  }

  componentDidUpdate(prevProps) {
    const prev = (prevProps.value || []).map(v => (typeof v === 'string' ? v : v?.value))
    const next = (this.props.value || []).map(v => (typeof v === 'string' ? v : v?.value))

    if (!arrEq(prev, next)) {
      this.setState({ value: (this.props.value || []).map(toOption) })
    }
  }

  render() {
    const {
      classes,
      parsedTags,
      isDisabled,
      defaultValue = [],
      isFullWidth,
      onHandleCreate = () => {},
      onHandleAddChip = () => {},
      isUpload,
      allowCreate = true,
    } = this.props

    const { value, inputValue } = this.state

    return (
      <CreatableSelect
        defaultValue={defaultValue}
        isMulti
        isValidNewOption={(inputValue, selectValue, selectOptions) => {
          if (!allowCreate) return false
          const isNotDuplicated = !selectOptions.map(option => option.label).includes(inputValue)
          const isNotEmpty = inputValue !== ''
          return isNotEmpty && isNotDuplicated
        }}
        onCreateOption={newText => {
          const newValues = [...this.state.value, { label: newText, value: newText }]
          this.setState({ inputValue: '', value: newValues })
          const parsedNewValues = newValues.map(t => t.value)
          return onHandleCreate && onHandleCreate(newText, parsedNewValues, isUpload)
        }}
        value={value}
        inputValue={inputValue}
        classNamePrefix="react-select"
        className={classNames(classes.menuMultiChip, isFullWidth && 'fullWidth')}
        options={parsedTags}
        isDisabled={isDisabled}
        menuPlacement="auto"
        menuPortalTarget={document.body}
        menuPosition="absolute"
        onInputChange={inputValue => this.setState({ inputValue })}
        onChange={(next = []) => {
          this.setState({ value: next })
          onHandleAddChip?.(next.map(t => t.value))
        }}
        placeholder="Tags"
        styles={{
          menuPortal: base => ({ ...base, zIndex: 1600 }),
          menu: base => ({ ...base, zIndex: 1600 }),
        }}
      />
    )
  }
}

export default withStyles(styles)(TagSelection)
